import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [

  {
    path: '',
    loadChildren: () =>
      import('./rechner/rechner.module').then((m) => m.RechnerPageModule),
  },
  {
    path: '**',
    redirectTo: '', // Redirect any undefined path to the home component
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],

})
export class AppRoutingModule {}
